import {
    apiRequest,
    PetaJabatanCreatePeriod
} from "../../../../../services/adapters/kepegawaian/PetaJabatanService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", PetaJabatanCreatePeriod, {
            body: query
        }, true)
    }


}

export default CreateRepository